/**
 * Resolves a stored file path (e.g. "student-photos/abc.jpg") to the URL
 * the browser can fetch. Returns null for blank input.
 *
 * The backend serves files from /api/files/{path}; this helper is what the
 * frontend should use to render <img src=...> for any photo_path / file_path.
 */
export function fileUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = import.meta.env.VITE_API_BASE_URL ?? '/api';
  // Path is stored as "{category}/{filename}"
  return `${base}/files/${path}`;
}
